<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import PedidosTable from './pedidos-table'
import appConfig from "@/app.config";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/pedidos_anim.json'
import exportFromJSON from "export-from-json"
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Pedidos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, PedidosTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted pedidos-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      animationJson,
      title: 'Pedidos',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Pedidos',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      pedidoList: null,
      pesqTextFilter: '',
      statusFilter: 'T',
      valorTotalConf: 0,
      valorTotalCanc: 0,
      valorTotalFat: 0,

      pedChart1: null,
      pedChart2: null,


      showModalPeriodo: false,
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null

    }
  },
  methods: {

    importarXML() {
      console.log('importarXML')
      this.$router.push('/pedido/importar/0')
    },


    confirmarPeriodo() {
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.atualizaDataList()

    },

    emitRelat001() {
      console.log('emitRelat001')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_pedidos_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat002() {
      console.log('emitRelat002')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped02`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_pedidos_002.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat003() {
      console.log('emitRelat003')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped03`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_pedidos_003.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    exportExcel() {
      console.log('exportExcel')
      const data = this.pedidoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({data, fileName, exportType});
    },

    atualizaDataList() {
      this.loadingList = true

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment().add(-30, 'days').startOf('month').format('YYYY-MM-DD')
        // let perIniPadrao = moment().add(-1, 'days').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      api.get(`${getBaseUrl()}api/pedidos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data[0])
        this.pedidoList = res.data[0]

        const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `(${this.pedidoList.length}) Pedidos: ${dtIniFormated} - ${dtFimFormated}`
        this.loadingList = false

        // console.log('res.data[1]')
        // console.log(res.data[1])


        let valorTotalLoc = 0
        let valorTotalConf = 0
        let valorTotalCanc = 0
        let valorTotalFat = 0
        this.pedidoList.forEach((value) => {

          valorTotalLoc += value.valorliq

          if (value.status === 'CA') {
            valorTotalCanc += value.valorliq
          } else if (value.status === 'CO') {
            valorTotalConf += value.valorliq
          } else if (value.status === 'FA' && value.stsefaz === 'AT') {
            valorTotalFat += value.valorliq
          }

        })

        this.valorTotal = valorTotalLoc
        this.valorTotalCanc = valorTotalCanc
        this.valorTotalConf = valorTotalConf
        this.valorTotalFat = valorTotalFat


        let labelsLocG1 = []
        let series01G1 = []
        let series02G1 = []
        let series03G1 = []
        res.data[1].forEach((value) => {
          labelsLocG1.push(value.month)
        })
        const uniquelabelsLocG1 = [...new Set(labelsLocG1)]
        // console.log('uniquelabelsLocG1')
        // console.log(uniquelabelsLocG1)
        uniquelabelsLocG1.forEach((value0) => {
          // console.log('value0')
          // console.log(value0)
          let acuFat = 0
          let acuCanc = 0
          let acuOutr = 0
          res.data[1].forEach((value1) => {
            if (value1.month === value0) {
              if (value1.status === 'FA') {
                acuFat += parseInt(value1.valor)
              } else if (value1.status === 'CA') {
                acuCanc += parseInt(value1.valor)
              } else {
                acuOutr += parseInt(value1.valor)
              }
            }
            //labelsLocG1.push(value.month)
          })
          series01G1.push(acuFat)
          series02G1.push(acuOutr)
          series03G1.push(acuCanc)
        })
        // console.log('series01G1')
        // console.log(series01G1)

        this.pedChart1 = {
          series: [{
            name: 'Faturado',
            type: 'area',
            data: series01G1
          }, {
            name: 'Outros',
            type: 'line',
            data: series02G1
          }, {
            name: 'Cancelado',
            type: 'column',
            data: series03G1
          }],
          chartOptions: {
            chart: {
              stacked: false,
              toolbar: {
                show: false
              }
            },
            stroke: {
              width: [0, 2, 4],
              curve: 'smooth'
            },
            plotOptions: {
              bar: {
                columnWidth: '50%'
              }
            },
            colors: ['#34c38f', '#556ee6', '#f46a6a'],
            fill: {
              opacity: [0.45, 0.85, 1],
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
              }
            },
            labels: uniquelabelsLocG1,
            markers: {
              size: 0
            },
            xaxis: {
              //type: 'datetime'
            },
            yaxis: {
              title: {
                text: 'Pedidos',
              },
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if (typeof y !== "undefined") {
                    return "R$ " + y.toFixed(0)
                  }
                  return y
                }
              }
            },
            grid: {
              borderColor: '#f1f1f1'
            }
          }
        }

        let labelsLocG2 = []
        let series01G2 = []
        let valorTotal = 0.00
        res.data[2].forEach((value) => {
          valorTotal += parseInt(value.valor)
        })
        console.log('valorTotal_G2')
        console.log(valorTotal)
        res.data[2].forEach((value) => {
          console.log(value)
          labelsLocG2.push(value.repres)

          const valorPerc = parseInt(value.valor / valorTotal * 100)
          console.log(valorPerc)

          series01G2.push(valorPerc)
        })


        this.pedChart2 = {

          series: series01G2,
          chartOptions: {
            labels: labelsLocG2,
            colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'center',
              verticalAlign: 'middle',
              floating: false,
              fontSize: '14px',
              offsetX: 0
            },
            responsive: [{
              breakpoint: 600,
              options: {
                chart: {
                  height: 240
                },
                legend: {
                  show: false
                },
              }
            }]
          }

        }


        this.loadingGraph = false
      })
    },

    criarNovo() {
      console.log('criarNovo')
      // this.updating = !this.updating
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }


  },


}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 170px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250"/>
    </span>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">


              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="CO">Confirmados</option>
                      <option value="FA">Faturados</option>
                      <option value="CA">Cancelados</option>
                      <option value="AB">Em Aberto</option>
                      <option value="QT">Quitados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatDecimal(valorTotal) }} (Valor Total) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Faturado:
                      <span class="float-end"> {{ formatDecimal(valorTotalFat) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Confirmado:
                      <span class="float-end"> {{ formatDecimal(valorTotalConf) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Cancelado:
                      <span class="float-end"> {{ formatDecimal(valorTotalCanc) }} (0%)</span>
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="exportExcel"
                       href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="importarXML"
                       href="javascript: void(0);">
                      Importar XML
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="emitRelat001"
                       href="javascript: void(0);">
                      Relatório de Pedidos Diário
                    </a>

                    <a class="dropdown-item text-primary text-center"
                       @click="emitRelat002"
                       href="javascript: void(0);">
                      Relatório de Pedidos Mês
                    </a>

                    <a class="dropdown-item text-primary text-center"
                       @click="emitRelat003"
                       href="javascript: void(0);">
                      Pedidos por Representante
                    </a>

                  </div>

                </b-dropdown>
              </div>


              <div class="col-sm-7">
                <div class="text-sm-end">
                  <router-link :to="`/orcamento/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2">
                      <i class="mdi mdi-plus me-1"></i> Novo Orçamento
                    </button>
                  </router-link>
                </div>
              </div>
            </div>


            <Loader v-if="loadingList" style="min-height: 400px;">
            </Loader>

            <PedidosTable v-if="!loadingList" :pedidoList="pedidoList"/>


            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Anual</h4>

            <apexchart
                class="apex-charts"
                height="350"
                type="line"
                dir="ltr"
                :series="pedChart1.series"
                :options="pedChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Representantes</h4>

            <apexchart
                class="apex-charts"
                height="320"
                type="pie"
                dir="ltr"
                :series="pedChart2.series"
                :options="pedChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>